import {
  Col,
  Row,
  Tabs,
  Grid,
  TabsProps,
  Tree,
  Typography,
  message,
  Card,
  Drawer,
  Space,
  Button,
  Segmented,
} from "antd";
import { ColorPalette } from "../share/color/colorPalette";
import logo from "../../assets/logo.png";
import CustomButton from "../share/customButton";
import CustomLabel from "../share/customLabel";
import InputWithIcons from "../share/InputWithIcons";
import { useEffect, useState } from "react";
import HintInput from "../share/hintInput";
import TedTitle from "../share/TedTitle";
import TedIcon from "../share/TedIcon";
import star from "../../assets/vectors/Star.svg";

import {
  ArrowRightOutlined,
  EditOutlined,
  EyeInvisibleOutlined,
  LeftOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import TedOTP from "../share/TedOTP";
import {
  CheckInvitationWithPhoneNumber,
  GetInvitationByInvitationCode,
  GetMyInvitations,
  InvitationAcceptByInvitationCode,
} from "../../services/InvitationService";
import { SendConfirmationCode } from "../../services/CommiunicationService";
import { useDispatch } from "react-redux";
import { CheckConfirm, SetPassword } from "../../services/AccountService";
import { fetchUserProfile } from "../../features/profile/profileSlice";
import { SetUserProfile } from "../../services/ProfileService";
import TedModal from "../share/TedModal";
import TedTab from "../share/TedTab";
import { useNavigate } from "react-router-dom";
import { CreateCompany } from "../../services/CompanyService";
import NotificationManagement from "../notifications/notificationManagement";
import { GetAllCategories } from "../../services/CategoryService";
import { DataNode } from "antd/es/tree";
import { fetchUserPosition } from "../../features/position/positionSlice";
import { GetMyPosition } from "../../services/PositionService";
import { GetCategoryPositionsByPositionId } from "../../services/NotificationPositionService";
import { NotificationManagementCreate } from "../../services/NotificationManagementService";
const { useBreakpoint } = Grid;
const RegisterV2 = () => {
  const screens = useBreakpoint();
  const [inputValue, setInputValue] = useState("");
  const [inputInvitationCode, setInputInvitationCode] = useState("");
  const [state, setState] = useState(0);

  //Stage 1 Functions start

  //# Timer Start
  const [seconds, setSeconds] = useState(180); // 3 minutes in seconds
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (isActive && seconds > 0) {
      interval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [isActive, seconds]);

  const toggleTimer = () => {
    setIsActive((prev) => !prev);
  };

  const resetTimer = () => {
    setSeconds(180); // Reset to 3 minutes
    setIsActive(false);
  };

  // Format seconds into minutes and seconds
  const formattedTime = `${Math.floor(seconds / 60)
    .toString()
    .padStart(2, "0")}:${(seconds % 60).toString().padStart(2, "0")}`;
  //# Timer End

  const [otp, setOtp] = useState("");
  const handleOtpChange = (newOtp: string) => {
    setOtp(newOtp);
  };

  //#Confirm PhoneNumber Start

  const ConfirmInformations = async () => {
    try {
      const data = SendConfirmationCode({
        phoneNumber: getPhoneNumber,
        isVerification: true,
      }).then(function (response: any) {
        if (response.data.statusCode === 400) {
          message.error(response.data.message);
        } else {
          setState(1);
          toggleTimer();
        }
      });
      return;
      CheckInvitationWithPhoneNumber(getPhoneNumber, getInvitationCode).then(
        (p) => {
          if (p.data.data === false) {
            message.error("کد دعوتنامه نامعتبر");
            return;
          } else {
            const data = SendConfirmationCode({
              phoneNumber: getPhoneNumber,
              isVerification: true,
            }).then(function (response: any) {
              if (response.data.statusCode === 400) {
                message.error(response.data.message);
              } else {
                setState(1);
                toggleTimer();
              }
            });
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  //#Confirm PhoneNumber End

  //Stage 1 Functions end

  //Stage 1 Validations Start

  function ValidatePhoneNumber() {
    setIsTouchedPhoneNumber(true);
    if (getPhoneNumber === "") {
      setIsFilledPhoneNumber(false);
    } else {
      setIsFilledPhoneNumber(true);
    }
    if (getPhoneNumber !== "" && getPhoneNumber.length !== 11) {
      setIsValidPhoneNumber(false);
    } else {
      setIsValidPhoneNumber(true);
    }
  }

  function ValidateInvitation() {
    setIsTouchedInvitationCode(true);
    if (getInvitationCode === "") {
      setIsFilledInvitationCode(false);
    } else {
      setIsFilledInvitationCode(true);
    }
  }
  const [openDrawer, setOpenDrawer] = useState(false);
  const [getIsFilledPhoneNumber, setIsFilledPhoneNumber] = useState(true);
  const [getIsValidPhoneNumber, setIsValidPhoneNumber] = useState(true);
  const [getIsFilledInvitationCode, setIsFilledInvitationCode] = useState(true);
  const [getPhoneNumber, setPhoneNumber] = useState("");
  const [getInvitationCode, setInvitationCode] = useState("0");
  const [getIsTouchedPhoneNumber, setIsTouchedPhoneNumber] = useState(false);
  const [getIsTouchedInvitationCode, setIsTouchedInvitationCode] =
    useState(false);
  //Stage 1 Validations End

  //Stage 2 Functions Start

  const convertToPersianDigits = (input: string) => {
    const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
    return input.replace(/[0-9]/g, (digit) => persianDigits[parseInt(digit)]);
  };

  const dispatch = useDispatch<any>();

  const CheckConfirmAsync = async () => {
    try {
      await CheckConfirm(getPhoneNumber, otp, getInvitationCode).then((p) => {
        if (p.status === 200) {
          localStorage.setItem("token", p.data.data.token);
          dispatch(fetchUserProfile()).then(() => {
            setState(2);
          });
        }
      });
    } catch (error) {
      message.error((error as any).response.data);
    }
  };

  //Stage 2 Functions End

  //Stage 3

  const [getPassword, setPassword] = useState("");
  const [getPasswordTouched, setPasswordTouched] = useState(false);
  const [getRepeatPassword, setRepeatPassword] = useState("");
  const [getRepeatPasswordTouched, setRepeatPasswordTouched] = useState(false);

  const [getFirstName, setFirstName] = useState("");
  const [getFirstNameTouched, setFirstNameTouched] = useState(false);
  const [getLastName, setLastName] = useState("");
  const [getLastNameTouched, setLastNameTouched] = useState(false);

  function RegisterBaseInformations() {
    SetPassword(getPassword, getRepeatPassword).then((p) => {
      if (p.data.statusCode === 200) {
        SetUserProfile(getFirstName, getLastName)
          .then(() => {
            dispatch(fetchUserProfile()).then(() => {});
          })
          .then(() => setState(3));
      }
    });
  }

  //Stage 3

  //Stage 4

  const navigate = useNavigate();
  const [getInvitationData, setInvitationData] = useState<any>(null);
  const [getInvitationText, setInvitationText] = useState("");
  const [getInvitationTextForState4, setInvitationTextForState4] = useState("");
  const [getOtherInvitations, setOtherInvitations] = useState([]);
  const [getOtherInvitationsModal, setOtherInvitationsModal] = useState(false);
  const [getCompanyName, setCompanyName] = useState("");
  const [getCompanyRegistrationCode, setCompanyRegistrationCode] = useState("");
  const [getIsEmptyCompanyName, setIsEmptyCompanyName] = useState(false);
  const [getIsEmptyRegistrationCode, setIsEmptyRegistrationCode] =
    useState(false);
  const [getInvitationNoticeId, setInvitationNoticeId] = useState("");

  useEffect(() => {
    if (getInvitationCode.toString().length > 5) {
      GetInvitationByInvitationCode(getInvitationCode).then((p) => {
        console.log("invitationData", p);
        setInvitationData(p.data.data);
        if (p.data.data !== undefined) {
          console.log("data", p.data.data);
          if (
            p?.data?.data?.noticeId !== null &&
            p?.data?.data?.noticeId !== undefined &&
            p?.data?.data?.noticeId !== ""
          ) {
            setInvitationNoticeId(p?.data?.data?.noticeId);
          }
          setInvitationText(
            ` شما توسط فروشگاه ${p?.data?.data?.company?.name} برای ثبت نام و فعالیت در این پلتفرم دعوت شده اید `
          );
          setInvitationTextForState4(
            `ثبت نام شما از طریق فروشگاه ${p?.data?.data?.company?.name} با سمت ${p?.data?.data?.position?.name} تکمیل شود؟`
          );
        }
      });
    }
  }, [getInvitationCode]);

  //stage 5

  const [getDrawerSegment, setDrawerSegment] = useState("C");

  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);
  const [checkedKeys, setCheckedKeys] = useState<React.Key[]>([]);
  const [selectedKeys, setSelectedKeys] = useState<React.Key[]>([]);
  const [autoExpandParent, setAutoExpandParent] = useState<boolean>(true);

  const onExpand = (expandedKeysValue: React.Key[]) => {
    console.log("onExpand", expandedKeysValue);

    console.log(expandedKeysValue);

    setExpandedKeys(expandedKeysValue);
    setAutoExpandParent(false);
  };

  const onCheck = (checkedKeysValue: any): any => {
    console.log("onCheck", checkedKeysValue);
    setCheckedKeys(checkedKeysValue);

    return undefined;
  };

  const [treeData, setTreeData] = useState<DataNode[]>([]);
  const [myPosition, SetMyPosition] = useState<any>("");
  useEffect(() => {
    setCheckedKeys([]);
    if (myPosition.id !== null && myPosition.id !== undefined) {
      GetCategoryPositionsByPositionId(myPosition.id).then((p) =>
        p.data.data.map((data: any) => {
          setCheckedKeys((prevItems) => [...prevItems, data.categoryId]);
        })
      );
    }
  }, [myPosition]);

  useEffect(() => {
    if (state === 3) {
      GetMyInvitations().then((p) => {
        console.log("All of My Invitations ", p.data.data);
        setOtherInvitations(p.data.data);
      });
    }

    if (state === 5) {
      GetAllCategories().then((p) => setTreeData(p.data.data));
      dispatch(fetchUserPosition());
      GetMyPosition().then((p) => {
        if (p.status === 200) {
          console.log("o.data", p.data);

          SetMyPosition(p.data);
        } else {
          SetMyPosition(null);
        }
      });
    }
  }, [state]);

  const onChange = (key: string) => {
    console.log(key);
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "دعوتنامه فروشگاهی",
      children: (
        <>
          {getOtherInvitations !== null && getOtherInvitations !== undefined ? (
            <>
              {getOtherInvitations
                .filter(
                  (item: any) =>
                    //item.invitationCode.code !== getInvitationCode &&

                    item?.invitationType === 1
                )
                .map((p: any) => {
                  return (
                    <>
                      <Row style={{ marginTop: "24px", width: "488px" }}>
                        <CustomButton
                          onClick={() =>
                            setInvitationCode(p?.invitationCode?.code)
                          }
                          customSize="Large"
                          customType="Secondary"
                          hasTitle={true}
                          style={{ width: "100%" }}
                        >
                          دعوتنامه فروشگاهی : {p?.company?.name}
                        </CustomButton>
                      </Row>
                    </>
                  );
                })}
            </>
          ) : (
            <></>
          )}
        </>
      ),
    },
    {
      key: "2",
      label: "دعوتنامه همکار",
      children: (
        <>
          {getOtherInvitations !== null && getOtherInvitations !== undefined ? (
            <>
              {getOtherInvitations
                .filter(
                  (item: any) =>
                    item.invitationCode.code !== getInvitationCode &&
                    !item.isDeleted &&
                    item?.invitationType === 0
                )
                .map((p: any) => {
                  return (
                    <>
                      <Row style={{ marginTop: "24px", width: "488px" }}>
                        <CustomButton
                          onClick={() =>
                            setInvitationCode(p?.invitationCode?.code)
                          }
                          customSize="Large"
                          customType="Secondary"
                          hasTitle={true}
                          style={{ width: "100%" }}
                        >
                          دعوتنامه همکار : {p?.company?.name} در سمت{" "}
                          {p?.position?.name}
                        </CustomButton>
                      </Row>
                    </>
                  );
                })}
            </>
          ) : (
            <></>
          )}
        </>
      ),
    },
  ];

  //Stage 4
  return (
    <>
      {!screens.xs ? (
        <>
          <Row className="main-row" style={{ height: "100vh" }}>
            <Col className="input-wizard-container" style={{ width: "50%" }}>
              <Col
                className="input-wizard"
                style={{
                  width: "708px",
                  height: "1024px",
                  backgroundColor: ColorPalette.primaryBlue[600],
                }}
              >
                <img src={star} height={"1024px"} />
              </Col>
            </Col>
            <Col className="input-wizard-container" style={{ width: "50%" }}>
              <Col
                style={{
                  width: "560px",
                  height: "610px",
                  display: state === 0 ? "block" : "none",
                }}
              >
                <Row>
                  <img
                    style={{
                      margin: "auto",
                      width: "187px",
                      height: "102px",
                    }}
                    src={logo}
                  />
                </Row>
                <Row
                  style={{
                    marginTop: "32px",
                    height: "42px",
                  }}
                >
                  <div
                    style={{
                      all: "initial",
                      backgroundColor: "transparent",
                      display: "block",
                      width: "100%",
                    }}
                  >
                    <div
                      className="iran text-divider"
                      style={{
                        color: ColorPalette.gray[950],
                        backgroundColor: "transparent",
                        fontSize: 16,
                        margin: "auto",
                        height: "42px",
                      }}
                    >
                      &nbsp; &nbsp;
                      {" قبلا ثبت نام کرده اید ؟ "}
                      &nbsp; &nbsp;
                    </div>
                  </div>
                </Row>
                <Row
                  className="iran"
                  style={{
                    height: "42px",
                    textAlign: "center",
                  }}
                >
                  <CustomButton
                    onClick={() => navigate("/Login")}
                    style={{ width: "100%" }}
                    type="link"
                    size="large"
                    hasTitle={true}
                  >
                    ورود به حساب کاربری
                  </CustomButton>
                </Row>
                <Row
                  style={{
                    height: "42px",
                    textAlign: "center",
                    marginTop: "29.5px",
                  }}
                >
                  <Typography.Text
                    className="iran"
                    style={{ fontSize: "40px", fontWeight: 600 }}
                  >
                    ثبت نام
                  </Typography.Text>
                </Row>
                <Row style={{ marginTop: "32px" }}>
                  <CustomLabel customSize="Large">
                    لطفا شماره موبایل خود را وارد کنید
                  </CustomLabel>
                </Row>
                <Row style={{ fontFamily: "YekanBakhVF" }}>
                  <InputWithIcons
                    size="large"
                    value={getPhoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    onBlur={(e) => ValidatePhoneNumber()}
                  />
                </Row>
                <Row style={{ marginTop: "12px" }}>
                  <div
                    style={{
                      display:
                        getIsFilledPhoneNumber === true ? "none" : "block",
                    }}
                  >
                    <HintInput customSize="Large" status="Error">
                      لطفا این قسمت را خالی نگذارید
                    </HintInput>
                  </div>
                  <div
                    style={{
                      display:
                        getIsValidPhoneNumber === true ? "none" : "block",
                    }}
                  >
                    <HintInput customSize="Large" status="Error">
                      شماره موبایل نادرست است
                    </HintInput>
                  </div>
                </Row>
                <Row style={{ marginTop: "24px" }}>
                  <CustomLabel customSize="Large">
                    لطفا کد دعوت را وارد کنید{" "}
                  </CustomLabel>
                </Row>
                <Row style={{ fontFamily: "YekanBakhVF" }}>
                  <InputWithIcons
                    size="large"
                    value={getInvitationCode}
                    onChange={(e) => {
                      setInvitationCode(e.target.value);
                    }}
                    onBlur={(e) => ValidateInvitation()}
                  />
                </Row>
                <Row style={{ marginTop: "12px" }}>
                  <div
                    style={{
                      display:
                        getIsFilledInvitationCode === true ? "none" : "block",
                    }}
                  >
                    <HintInput customSize="Large" status="Error">
                      لطفا این قسمت را خالی نگذارید
                    </HintInput>
                  </div>
                </Row>
                <Row style={{ marginTop: "36px" }}>
                  <CustomButton
                    onClick={() => {
                      if (getPhoneNumber.length !== 11) {
                        setIsValidPhoneNumber(false);
                        return;
                      } else {
                        setIsValidPhoneNumber(true);
                      }
                      ConfirmInformations();
                    }}
                    disabled={
                      getPhoneNumber.length !== 11
                      //  || getInvitationCode.length !== 6
                    }
                    customSize="Large"
                    type="primary"
                    hasTitle={true}
                    style={{ width: "100%" }}
                  >
                    تایید
                  </CustomButton>
                </Row>
              </Col>
              <Col
                style={{
                  width: "560px",
                  height: "610px",
                  display: state === 1 ? "block" : "none",
                }}
              >
                <Row>
                  <img
                    style={{
                      margin: "auto",
                      width: "187px",
                      height: "102px",
                    }}
                    src={logo}
                  />
                </Row>
                <Row
                  style={{
                    marginTop: "32px",
                    height: "42px",
                  }}
                >
                  <TedIcon Icon={ArrowRightOutlined} />
                  <TedTitle text="ارسال کد" />
                </Row>
                <Row
                  style={{
                    marginTop: "32px",
                    height: "77px",
                    gap: "4px",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    <CustomLabel customSize="Large">
                      لطفا کد ارسال شده به شماره موبایل{" "}
                      {convertToPersianDigits(getPhoneNumber)} را وارد کنید
                    </CustomLabel>
                    <CustomButton
                      style={{ backgroundColor: "transparent" }}
                      RightIconEnabled
                      hasTitle
                      RightIcon={EditOutlined}
                      customType="Link"
                      customSize="Large"
                      onClick={() => setState(0)}
                    >
                      ویرایش شماره
                    </CustomButton>
                  </div>
                </Row>
                <Row
                  style={{
                    marginTop: "24px",
                    height: "64px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    <TedOTP length={5} onChange={handleOtpChange} />
                  </div>
                </Row>
                <Row
                  style={{
                    marginTop: "24px",
                  }}
                >
                  <div style={{ width: "100%", textAlign: "center" }}>
                    <CustomButton
                      LeftIconEnabled
                      LeftIcon={LoadingOutlined}
                      hasTitle
                      customType="Text"
                    >
                      ارسال مجدد کد تا {formattedTime}
                    </CustomButton>
                  </div>
                </Row>
                <Row
                  style={{
                    marginTop: "48px",
                  }}
                >
                  <CustomButton
                    onClick={() => {
                      CheckConfirmAsync();
                    }}
                    customSize="Large"
                    type="primary"
                    hasTitle={true}
                    disabled={otp.length !== 5}
                    style={{ width: "100%" }}
                  >
                    تایید
                  </CustomButton>
                </Row>
              </Col>
              <Col
                style={{
                  width: "560px",
                  height: "610px",
                  display: state === 2 ? "block" : "none",
                }}
              >
                <Row>
                  <img
                    style={{
                      margin: "auto",
                      width: "187px",
                      height: "102px",
                    }}
                    src={logo}
                  />
                </Row>
                <Row
                  style={{
                    marginTop: "32px",
                    height: "42px",
                  }}
                >
                  <TedIcon Icon={ArrowRightOutlined} />
                  <TedTitle text="ورود اطلاعات پایه" />
                </Row>
                <Row style={{ marginTop: "32px" }}>
                  <CustomLabel customSize="Large">نام</CustomLabel>
                </Row>
                <Row style={{ fontFamily: "YekanBakhVF" }}>
                  <InputWithIcons
                    size="large"
                    value={getFirstName}
                    onBlur={() => {
                      setFirstNameTouched(true);
                    }}
                    onChange={(e) => {
                      setFirstName(e.target.value);
                    }}
                  />
                </Row>
                <Row style={{ marginTop: "12px" }}>
                  <div
                    style={{
                      display:
                        getFirstName === "" && getFirstNameTouched
                          ? "block"
                          : "none",
                    }}
                  >
                    <HintInput customSize="Large" status="Error">
                      لطفا این قسمت را خالی نگذارید
                    </HintInput>
                  </div>
                </Row>
                <Row style={{ marginTop: "32px" }}>
                  <CustomLabel customSize="Large">نام خانوادگی</CustomLabel>
                </Row>

                <Row style={{ fontFamily: "YekanBakhVF" }}>
                  <InputWithIcons
                    size="large"
                    value={getLastName}
                    onBlur={() => {
                      setLastNameTouched(true);
                    }}
                    onChange={(e) => {
                      setLastName(e.target.value);
                    }}
                  />
                </Row>
                <Row style={{ marginTop: "12px" }}>
                  <div
                    style={{
                      display:
                        getLastName === "" && getLastNameTouched
                          ? "block"
                          : "none",
                    }}
                  >
                    <HintInput customSize="Large" status="Error">
                      لطفا این قسمت را خالی نگذارید
                    </HintInput>
                  </div>
                </Row>
                <Row style={{ marginTop: "32px" }}>
                  <CustomLabel customSize="Large">
                    لطفا رمز عبور را وارد کنید
                  </CustomLabel>
                </Row>
                <Row style={{ fontFamily: "YekanBakhVF" }}>
                  <InputWithIcons
                    LeftIconEnabled={true}
                    LeftIcon={LeftOutlined}
                    size="large"
                    value={getPassword}
                    type="password"
                    onBlur={() => {
                      setPasswordTouched(true);
                    }}
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                  />
                </Row>
                <Row style={{ marginTop: "12px" }}>
                  <div
                    style={{
                      display:
                        getPassword === "" && getPasswordTouched
                          ? "block"
                          : "none",
                    }}
                  >
                    <HintInput customSize="Large" status="Error">
                      لطفا این قسمت را خالی نگذارید
                    </HintInput>
                  </div>
                </Row>

                <Row style={{ marginTop: "24px" }}>
                  <CustomLabel customSize="Large">
                    لطفا رمز عبور را مجددا وارد کنید
                  </CustomLabel>
                </Row>
                <Row style={{ fontFamily: "YekanBakhVF" }}>
                  <InputWithIcons
                    LeftIconEnabled={true}
                    LeftIcon={LeftOutlined}
                    size="large"
                    type="password"
                    value={getRepeatPassword}
                    onBlur={() => {
                      setRepeatPasswordTouched(true);
                    }}
                    onChange={(e) => {
                      setRepeatPassword(e.target.value);
                    }}
                  />
                </Row>
                <Row style={{ marginTop: "12px" }}>
                  <div
                    style={{
                      display:
                        getRepeatPassword === "" && getRepeatPasswordTouched
                          ? "block"
                          : "none",
                    }}
                  >
                    <HintInput customSize="Large" status="Error">
                      لطفا این قسمت را خالی نگذارید
                    </HintInput>
                  </div>
                </Row>

                <Row style={{ marginTop: "12px" }}>
                  <div
                    style={{
                      display:
                        getRepeatPasswordTouched &&
                        getRepeatPassword !== getPassword
                          ? "block"
                          : "none",
                    }}
                  >
                    <HintInput customSize="Large" status="Error">
                      رمز عبور و تکرار آن باهم تطبیق ندارند
                    </HintInput>
                  </div>
                </Row>
                <Row style={{ marginTop: "36px" }}>
                  <CustomButton
                    onClick={() => {
                      RegisterBaseInformations();
                    }}
                    disabled={
                      getRepeatPasswordTouched &&
                      getRepeatPassword !== getPassword
                    }
                    customSize="Large"
                    type="primary"
                    hasTitle={true}
                    style={{ width: "100%" }}
                  >
                    تایید
                  </CustomButton>
                </Row>
              </Col>
              <Col
                style={{
                  width: "560px",
                  height: "610px",
                  display: state === 3 ? "block" : "none",
                }}
              >
                <Row>
                  <img
                    style={{
                      margin: "auto",
                      width: "187px",
                      height: "102px",
                    }}
                    src={logo}
                  />
                </Row>
                <Row
                  style={{
                    textAlign: "center",
                    marginTop: "8px",
                    height: "34px",
                  }}
                >
                  <div style={{ width: "100%", textAlign: "center" }}>
                    <TedTitle
                      style={{ fontWeight: "600", fontSize: "24px" }}
                      text="به دیجیتال آگهی خوش آمدید"
                    />
                  </div>
                </Row>
                <Row
                  style={{
                    marginTop: "48px",
                    height: "34px",
                  }}
                >
                  <div style={{ width: "100%", textAlign: "center" }}>
                    <TedTitle
                      style={{ fontWeight: "325", fontSize: "16px" }}
                      text={getInvitationText}
                    />
                  </div>
                </Row>
                <Row
                  style={{
                    marginTop: "48px",
                    height: "34px",
                  }}
                >
                  <div style={{ width: "100%", textAlign: "center" }}>
                    <TedTitle
                      style={{ fontWeight: "600", fontSize: "20px" }}
                      text="با قبول دعوت نامه مراحل ثبت نام شما شروع میشود"
                    />
                  </div>
                </Row>
                <Row style={{ marginTop: "48px" }}>
                  <CustomButton
                    onClick={() => setState(4)}
                    customSize="Large"
                    type="primary"
                    hasTitle={true}
                    style={{ width: "100%" }}
                  >
                    قبول دعوتنامه
                  </CustomButton>
                </Row>
                <Row
                  style={{
                    marginTop: "24px",
                    height: "45px",
                  }}
                >
                  <div
                    style={{
                      all: "initial",
                      backgroundColor: "transparent",
                      display: "block",
                      width: "100%",
                    }}
                  >
                    <div
                      className="iran text-divider"
                      style={{
                        color: ColorPalette.gray[950],
                        backgroundColor: "transparent",
                        fontSize: 16,
                        margin: "auto",
                        height: "45px",
                      }}
                    >
                      &nbsp; &nbsp;
                      {" دعوتنامه فروشگاه های دیگر "}
                      &nbsp; &nbsp;
                    </div>
                  </div>
                </Row>
                {getOtherInvitations
                  .filter(
                    (item: any) =>
                      item.invitationCode.code !== getInvitationCode &&
                      !item.isDeleted
                  )
                  .slice(0, 2)
                  .map((p: any) => {
                    return (
                      <>
                        {" "}
                        {p.invitationType === 0 ? (
                          <>
                            <Row style={{ marginTop: "24px" }}>
                              <CustomButton
                                onClick={() =>
                                  setInvitationCode(p?.invitationCode?.code)
                                }
                                customSize="Large"
                                customType="Secondary"
                                hasTitle={true}
                                style={{ width: "100%" }}
                              >
                                دعوتنامه همکار : {p.company.name} در سمت{" "}
                                {p.position.name}
                              </CustomButton>
                            </Row>
                          </>
                        ) : (
                          <>
                            <Row style={{ marginTop: "24px" }}>
                              <CustomButton
                                onClick={() =>
                                  setInvitationCode(p?.invitationCode?.code)
                                }
                                customSize="Large"
                                customType="Secondary"
                                hasTitle={true}
                                style={{ width: "100%" }}
                              >
                                دعوتنامه فروشگاهی : {p.company.name}
                              </CustomButton>
                            </Row>
                          </>
                        )}{" "}
                      </>
                    );
                  })}
                <Row style={{ marginTop: "24px" }}>
                  <CustomButton
                    customSize="XLarge"
                    customType="Link"
                    hasTitle={true}
                    onClick={() => {
                      GetMyInvitations().then((p) => {
                        console.log("All of My Invitations ", p.data.data);
                        setOtherInvitations(p.data.data);
                      });
                      console.log(getOtherInvitations);

                      setOtherInvitationsModal(true);
                    }}
                    style={{ width: "220px", margin: "auto" }}
                  >
                    مشاهده همه دعوتنامه ها
                  </CustomButton>
                </Row>
              </Col>
              <Col
                style={{
                  width: "560px",
                  height: "610px",
                  display: state === 4 ? "block" : "none",
                }}
              >
                <Row>
                  <img
                    style={{
                      margin: "auto",
                      width: "187px",
                      height: "102px",
                    }}
                    src={logo}
                  />
                </Row>

                {getInvitationData?.invitationType === 0 ? (
                  <>
                    <Row
                      style={{
                        textAlign: "center",
                        marginTop: "8px",
                        height: "34px",
                      }}
                    >
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <TedTitle
                          style={{ fontWeight: "600", fontSize: "24px" }}
                          text="به دیجیتال آگهی خوش آمدید"
                        />
                      </div>
                    </Row>

                    <Row
                      style={{
                        marginTop: "48px",
                        height: "34px",
                      }}
                    >
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <TedTitle
                          style={{ fontWeight: "600", fontSize: "16px" }}
                          text={getInvitationTextForState4}
                        />
                      </div>
                    </Row>
                    <Row style={{ marginTop: "48px" }}>
                      <CustomButton
                        customSize="Large"
                        onClick={() => {
                          InvitationAcceptByInvitationCode(
                            getInvitationCode,
                            getPhoneNumber
                          ).then((p) => {
                            navigate("/");
                          });
                        }}
                        type="primary"
                        hasTitle={true}
                        style={{ width: "100%" }}
                      >
                        تایید
                      </CustomButton>
                    </Row>
                    <Row style={{ marginTop: "24px" }}>
                      <CustomButton
                        onClick={() => setState(3)}
                        customSize="Large"
                        customType="Secondary"
                        hasTitle={true}
                        style={{ width: "100%" }}
                      >
                        بازگشت
                      </CustomButton>
                    </Row>
                  </>
                ) : (
                  <>
                    <Row
                      style={{
                        height: "42px",
                        textAlign: "center",
                        marginTop: "29.5px",
                      }}
                    >
                      <Typography.Text
                        className="iran"
                        style={{ fontSize: "40px", fontWeight: 600 }}
                      >
                        تکمیل ثب نام
                      </Typography.Text>
                    </Row>
                    <Row style={{ marginTop: "32px" }}>
                      <CustomLabel customSize="Large">
                        لطفا نام خود / فروشگاه را وارد کنید
                      </CustomLabel>
                    </Row>
                    <Row style={{ fontFamily: "YekanBakhVF" }}>
                      <InputWithIcons
                        size="large"
                        value={getCompanyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                      />
                    </Row>
                    <Row style={{ marginTop: "12px" }}>
                      <div
                        style={{
                          display:
                            getIsEmptyCompanyName === false ? "none" : "block",
                        }}
                      >
                        <HintInput customSize="Large" status="Error">
                          لطفا این قسمت را خالی نگذارید
                        </HintInput>
                      </div>
                    </Row>
                    <Row style={{ marginTop: "24px" }}>
                      <CustomLabel customSize="Large">
                        لطفا شماره ملی خود را وارد کنید{" "}
                      </CustomLabel>
                    </Row>
                    <Row style={{ fontFamily: "YekanBakhVF" }}>
                      <InputWithIcons
                        size="large"
                        value={getCompanyRegistrationCode}
                        onChange={(e) =>
                          setCompanyRegistrationCode(e.target.value)
                        }
                      />
                    </Row>
                    <Row style={{ marginTop: "12px" }}>
                      <div
                        style={{
                          display:
                            getIsEmptyRegistrationCode === false
                              ? "none"
                              : "block",
                        }}
                      >
                        <HintInput customSize="Large" status="Error">
                          لطفا این قسمت را خالی نگذارید
                        </HintInput>
                      </div>
                    </Row>
                    <Row style={{ marginTop: "36px" }}>
                      <CustomButton
                        onClick={() => {
                          if (getCompanyName.trim() === "") {
                            setIsEmptyCompanyName(true);
                            return;
                          } else {
                            setIsEmptyCompanyName(false);
                          }

                          if (getCompanyRegistrationCode.trim() === "") {
                            setIsEmptyRegistrationCode(true);
                            return;
                          } else {
                            setIsEmptyRegistrationCode(false);
                          }
                          CreateCompany({
                            name: getCompanyName,
                            registrationCode: getCompanyRegistrationCode,
                            invitationCode: getInvitationCode,
                          }).then(() => setState(5));
                        }}
                        customSize="Large"
                        type="primary"
                        hasTitle={true}
                        style={{ width: "100%" }}
                      >
                        تایید
                      </CustomButton>
                    </Row>
                  </>
                )}
              </Col>
              <Col
                style={{
                  width: "560px",
                  height: "610px",
                  display: state === 5 ? "block" : "none",
                }}
              >
                <Row>
                  <img
                    style={{
                      margin: "auto",
                      width: "187px",
                      height: "102px",
                    }}
                    src={logo}
                  />
                </Row>{" "}
                <Row>
                  <Typography.Text
                    className="iran"
                    style={{ fontSize: "40px", fontWeight: 600 }}
                  >
                    زمینه کاری
                  </Typography.Text>
                </Row>
                <Row style={{ marginTop: "56px" }}>
                  <Tree
                    className="iran"
                    checkable
                    onExpand={onExpand}
                    expandedKeys={expandedKeys}
                    autoExpandParent={autoExpandParent}
                    onCheck={onCheck}
                    checkedKeys={checkedKeys}
                    selectedKeys={selectedKeys}
                    treeData={treeData}
                  />
                </Row>
                <Row style={{ marginTop: "48px" }}>
                  <CustomButton
                    customSize="Large"
                    onClick={async () =>
                      NotificationManagementCreate({
                        PositionId: myPosition.id,
                        CategoryIds: checkedKeys,
                      }).then((p) => {
                        if (getInvitationNoticeId === "") {
                          navigate("/");
                        } else {
                          navigate(`/notice/${getInvitationNoticeId}`);
                        }
                      })
                    }
                    type="primary"
                    hasTitle={true}
                    style={{ width: "100%" }}
                  >
                    تایید
                  </CustomButton>
                </Row>
              </Col>
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Row>
            <Col
              style={{
                height: "100%",
                width: "100%",
              }}
            >
              <Col
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "350px",
                  zIndex: -1,
                  backgroundColor: ColorPalette.primaryBlue[600],
                }}
              >
                <img src={star} height={"50%"} />
              </Col>
              <Col style={{ display: state === 0 ? "block" : "none" }}>
                <Row
                  style={{
                    marginTop: "32px",
                    height: "42px",
                  }}
                >
                  <div
                    style={{
                      margin: "auto",
                      backgroundColor: "transparent",
                      display: "block",
                      width: "345px",
                    }}
                  >
                    <div
                      className="iran text-divider"
                      style={{
                        color: "white",
                        backgroundColor: "transparent",
                        fontSize: 16,
                        margin: "auto",
                        height: "42px",
                      }}
                    >
                      &nbsp; &nbsp;
                      {"قبلا ثبت نام کرده اید؟"}
                      &nbsp; &nbsp;
                    </div>
                  </div>
                </Row>
                <Row
                  className="iran"
                  style={{
                    marginTop: "8px",
                    textAlign: "center",
                  }}
                >
                  <CustomButton
                    style={{
                      margin: "auto",
                      backgroundColor: ColorPalette.gray[950],
                      width: "319px",
                      borderRadius: "4px",
                    }}
                    onClick={() => navigate("/login")}
                    type="primary"
                    size="large"
                    hasTitle={true}
                  >
                    ورود به حساب کاربری
                  </CustomButton>
                </Row>
                <Row
                  className="iran"
                  style={{
                    marginTop: "40px",
                  }}
                >
                  <Card
                    style={{ height: "551px", width: "319px", margin: "auto" }}
                  >
                    <Col
                      style={{
                        width: "560px",
                        height: "610px",
                        display: state === 0 ? "block" : "none",
                      }}
                    >
                      <Row
                        style={{
                          height: "42px",
                          textAlign: "center",
                          marginTop: "29.5px",
                        }}
                      >
                        <Typography.Text
                          className="iran"
                          style={{ fontSize: "24px", fontWeight: 600 }}
                        >
                          ثبت نام
                        </Typography.Text>
                      </Row>
                      <Row style={{ marginTop: "32px" }}>
                        <CustomLabel
                          style={{ fontSize: "16px", fontWeight: "325" }}
                          customSize="XLarge"
                        >
                          لطفا شماره موبایل خود را وارد کنید
                        </CustomLabel>
                      </Row>
                      <Row style={{ fontFamily: "YekanBakhVF" }}>
                        <InputWithIcons
                          size="large"
                          value={getPhoneNumber}
                          onChange={(e) => setPhoneNumber(e.target.value)}
                          onBlur={(e) => ValidatePhoneNumber()}
                        />
                      </Row>
                      <Row style={{ marginTop: "12px" }}>
                        <div
                          style={{
                            display:
                              getIsFilledPhoneNumber === true
                                ? "none"
                                : "block",
                          }}
                        >
                          <HintInput customSize="Large" status="Error">
                            لطفا این قسمت را خالی نگذارید
                          </HintInput>
                        </div>
                        <div
                          style={{
                            display:
                              getIsValidPhoneNumber === true ? "none" : "block",
                          }}
                        >
                          <HintInput customSize="Large" status="Error">
                            شماره موبایل نادرست است
                          </HintInput>
                        </div>
                      </Row>
                      <Row style={{ marginTop: "24px" }}>
                        <CustomLabel
                          style={{ fontSize: "16px", fontWeight: "325" }}
                          customSize="XLarge"
                        >
                          لطفا کد دعوت را وارد کنید{" "}
                        </CustomLabel>
                      </Row>
                      <Row style={{ fontFamily: "YekanBakhVF" }}>
                        <InputWithIcons
                          size="xlarge"
                          type="text"
                          value={getInvitationCode}
                          onChange={(e) => setInvitationCode(e.target.value)}
                        />
                      </Row>
                      <Row style={{ marginTop: "12px" }}>
                        <div
                          style={{
                            display:
                              getIsFilledInvitationCode === true
                                ? "none"
                                : "block",
                          }}
                        >
                          <HintInput customSize="XLarge" status="Error">
                            لطفا این قسمت را خالی نگذارید
                          </HintInput>
                        </div>
                      </Row>
                      <Row style={{ marginTop: "36px" }}>
                        <CustomButton
                          onClick={() => {
                            if (getPhoneNumber.length !== 11) {
                              setIsValidPhoneNumber(false);
                              return;
                            } else {
                              setIsValidPhoneNumber(true);
                            }
                            ConfirmInformations();
                          }}
                          disabled={
                            getPhoneNumber.length !== 11 ||
                            getInvitationCode.length !== 6
                          }
                          customSize="Large"
                          type="primary"
                          hasTitle={true}
                          style={{ width: "100%" }}
                        >
                          تایید
                        </CustomButton>
                      </Row>
                      <Row
                        className="iran"
                        style={{
                          marginTop: "21.5px",
                          height: "40px",
                          textAlign: "center",
                        }}
                      ></Row>
                    </Col>
                  </Card>
                </Row>
              </Col>
              <Col style={{ display: state === 1 ? "block" : "none" }}>
                <Row
                  className="iran"
                  style={{
                    marginTop: "40px",
                  }}
                >
                  <Card
                    style={{ height: "551px", width: "319px", margin: "auto" }}
                  >
                    <Col>
                      <Row
                        style={{
                          height: "42px",
                          textAlign: "right",
                          marginTop: "29.5px",
                        }}
                      >
                        {/* <TedIcon Icon={ArrowRightOutlined} /> */}
                        <TedTitle customSize="XLarge" text="ارسال کد" />
                      </Row>
                      <Row
                        style={{
                          marginTop: "8px",
                          height: "77px",
                          gap: "4px",
                          textAlign: "center",
                        }}
                      >
                        <div
                          style={{
                            textAlign: "center",
                            width: "100%",
                          }}
                        >
                          <CustomLabel
                            style={{ fontSize: "16px", fontWeight: "325" }}
                            customSize="XLarge"
                          >
                            لطفا کد ارسال شده به شماره موبایل{" "}
                            {convertToPersianDigits(getPhoneNumber)} را وارد
                            کنید
                          </CustomLabel>
                          <CustomButton
                            style={{ backgroundColor: "transparent" }}
                            RightIconEnabled
                            hasTitle
                            RightIcon={EditOutlined}
                            customType="Link"
                            customSize="Large"
                            onClick={() => setState(0)}
                          >
                            ویرایش شماره
                          </CustomButton>
                        </div>
                      </Row>

                      <Row
                        style={{ marginTop: "24px", fontFamily: "YekanBakhVF" }}
                      >
                        <TedOTP length={5} onChange={handleOtpChange} />
                      </Row>

                      <Row
                        style={{
                          marginTop: "24px",
                        }}
                      >
                        <div style={{ width: "100%", textAlign: "center" }}>
                          <CustomButton
                            LeftIconEnabled
                            LeftIcon={LoadingOutlined}
                            hasTitle
                            customType="Text"
                          >
                            ارسال مجدد کد تا {formattedTime}
                          </CustomButton>
                        </div>
                      </Row>
                      <Row
                        style={{
                          marginTop: "36px",
                        }}
                      >
                        <CustomButton
                          onClick={() => {
                            CheckConfirmAsync();
                          }}
                          customSize="XLarge"
                          type="primary"
                          hasTitle={true}
                          disabled={otp.length !== 5}
                          style={{ width: "100%" }}
                        >
                          تایید
                        </CustomButton>
                      </Row>
                    </Col>
                  </Card>
                </Row>
              </Col>
              <Col style={{ display: state === 2 ? "block" : "none" }}>
                <Row
                  className="iran"
                  style={{
                    marginTop: "40px",
                  }}
                >
                  <Card
                    style={{ height: "691px", width: "319px", margin: "auto" }}
                  >
                    <Col
                      style={{
                        width: "560px",
                        height: "610px",
                      }}
                    >
                      <Row
                        style={{
                          marginTop: "32px",
                          height: "42px",
                        }}
                      >
                        {/* <TedIcon Icon={ArrowRightOutlined} /> */}
                        <TedTitle text="ورود اطلاعات اصلی" />
                      </Row>
                      <Row style={{ marginTop: "8px" }}>
                        <CustomLabel
                          style={{ fontSize: "16px", fontWeight: "325" }}
                          customSize="XLarge"
                        >
                          نام
                        </CustomLabel>
                      </Row>
                      <Row style={{ fontFamily: "YekanBakhVF" }}>
                        <InputWithIcons
                          size="xlarge"
                          value={getFirstName}
                          onBlur={() => {
                            setFirstNameTouched(true);
                          }}
                          onChange={(e) => {
                            setFirstName(e.target.value);
                          }}
                        />
                      </Row>
                      <Row>
                        <div
                          style={{
                            marginTop: "6px",
                            display:
                              getFirstName === "" && getFirstNameTouched
                                ? "block"
                                : "none",
                          }}
                        >
                          <HintInput customSize="XLarge" status="Error">
                            لطفا این قسمت را خالی نگذارید
                          </HintInput>
                        </div>
                      </Row>
                      <Row style={{ marginTop: "28px" }}>
                        <CustomLabel
                          style={{ fontSize: "16px", fontWeight: "325" }}
                          customSize="XLarge"
                        >
                          نام خانوادگی
                        </CustomLabel>
                      </Row>

                      <Row style={{ fontFamily: "YekanBakhVF" }}>
                        <InputWithIcons
                          size="xlarge"
                          value={getLastName}
                          onBlur={() => {
                            setLastNameTouched(true);
                          }}
                          onChange={(e) => {
                            setLastName(e.target.value);
                          }}
                        />
                      </Row>
                      <Row>
                        <div
                          style={{
                            marginTop: "6px",
                            display:
                              getLastName === "" && getLastNameTouched
                                ? "block"
                                : "none",
                          }}
                        >
                          <HintInput customSize="XLarge" status="Error">
                            لطفا این قسمت را خالی نگذارید
                          </HintInput>
                        </div>
                      </Row>
                      <Row style={{ marginTop: "28px" }}>
                        <CustomLabel
                          style={{ fontSize: "16px", fontWeight: "325" }}
                          customSize="XLarge"
                        >
                          لطفا رمز عبور را وارد کنید
                        </CustomLabel>
                      </Row>

                      <Row style={{ fontFamily: "YekanBakhVF" }}>
                        <InputWithIcons
                          LeftIconEnabled={true}
                          LeftIcon={EyeInvisibleOutlined}
                          size="xlarge"
                          value={getPassword}
                          type="password"
                          onBlur={() => {
                            setPasswordTouched(true);
                          }}
                          onChange={(e) => {
                            setPassword(e.target.value);
                          }}
                        />
                      </Row>
                      <Row>
                        <div
                          style={{
                            marginTop: "6px",
                            display:
                              getPassword === "" && getPasswordTouched
                                ? "block"
                                : "none",
                          }}
                        >
                          <HintInput customSize="XLarge" status="Error">
                            لطفا این قسمت را خالی نگذارید
                          </HintInput>
                        </div>
                      </Row>

                      <Row style={{ marginTop: "28px" }}>
                        <CustomLabel
                          style={{ fontSize: "16px", fontWeight: "325" }}
                          customSize="XLarge"
                        >
                          لطفا رمز عبور را مجددا وارد کنید
                        </CustomLabel>
                      </Row>
                      <Row style={{ fontFamily: "YekanBakhVF" }}>
                        <InputWithIcons
                          LeftIconEnabled={true}
                          LeftIcon={EyeInvisibleOutlined}
                          size="xlarge"
                          type="password"
                          value={getRepeatPassword}
                          onBlur={() => {
                            setRepeatPasswordTouched(true);
                          }}
                          onChange={(e) => {
                            setRepeatPassword(e.target.value);
                          }}
                        />
                      </Row>
                      <Row>
                        <div
                          style={{
                            marginTop: "6px",
                            display:
                              getRepeatPassword === "" &&
                              getRepeatPasswordTouched
                                ? "block"
                                : "none",
                          }}
                        >
                          <HintInput customSize="XLarge" status="Error">
                            لطفا این قسمت را خالی نگذارید
                          </HintInput>
                        </div>
                      </Row>

                      <Row style={{}}>
                        <div
                          style={{
                            marginTop: "6px",
                            display:
                              getRepeatPasswordTouched &&
                              getRepeatPassword !== getPassword
                                ? "block"
                                : "none",
                          }}
                        >
                          <HintInput customSize="Large" status="Error">
                            رمز عبور و تکرار آن باهم تطبیق ندارند
                          </HintInput>
                        </div>
                      </Row>
                      <Row style={{ marginTop: "32px" }}>
                        <CustomButton
                          onClick={() => {
                            RegisterBaseInformations();
                          }}
                          disabled={
                            getRepeatPasswordTouched &&
                            getRepeatPassword !== getPassword
                          }
                          customSize="XLarge"
                          type="primary"
                          hasTitle={true}
                          style={{ width: "100%" }}
                        >
                          تایید
                        </CustomButton>
                      </Row>
                    </Col>
                  </Card>
                </Row>
              </Col>
              <Col style={{ display: state === 3 ? "block" : "none" }}>
                <Row
                  className="iran"
                  style={{
                    marginTop: "10px",
                  }}
                >
                  <Col
                    style={{
                      width: "560px",
                      height: "610px",
                      display: state === 3 ? "block" : "none",
                    }}
                  >
                    <Row>
                      <img
                        style={{
                          margin: "auto",
                          width: "187px",
                          height: "102px",
                        }}
                        src={logo}
                      />
                    </Row>
                    <Row
                      style={{
                        textAlign: "center",
                        marginTop: "8px",
                        height: "22px",
                      }}
                    >
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <TedTitle
                          style={{
                            fontWeight: "600",
                            fontSize: "16px",
                            color: "white",
                            lineHeight: "22.4px",
                            fontFamily: "YekanBakhVF",
                          }}
                          text="به دیجیتال آگهی خوش آمدید"
                        />
                      </div>
                    </Row>
                    <Row
                      style={{
                        marginTop: "21px",
                        height: "58px",
                      }}
                    >
                      <div
                        style={{
                          width: "320px",
                          margin: "auto",
                          textAlign: "center",
                        }}
                      >
                        <TedTitle
                          style={{
                            fontWeight: "325",
                            fontSize: "16px",
                            color: "white",
                            lineHeight: "28.8px",
                          }}
                          text={getInvitationText}
                        />
                      </div>
                    </Row>
                    <Row
                      style={{
                        marginTop: "18px",
                        height: "56px",
                      }}
                    >
                      <div
                        style={{
                          width: "320px",
                          margin: "auto",
                          textAlign: "center",
                        }}
                      >
                        <TedTitle
                          style={{
                            fontWeight: "600",
                            fontSize: "20px",
                            color: "white",
                          }}
                          text="با قبول دعوت نامه مراحل ثبت نام شما شروع میشود"
                        />
                      </div>
                    </Row>
                    <Row style={{ marginTop: "32px" }}>
                      <CustomButton
                        onClick={() => setState(4)}
                        customSize="XLarge"
                        type="primary"
                        hasTitle={true}
                        style={{
                          width: "320px",
                          margin: "auto",
                          backgroundColor: ColorPalette.gray["950"],
                        }}
                      >
                        قبول دعوت نامه
                      </CustomButton>
                    </Row>
                    <Row
                      style={{
                        marginTop: "24px",
                        height: "45px",
                      }}
                    >
                      <div
                        style={{
                          all: "initial",
                          backgroundColor: "transparent",
                          display: "block",
                          width: "100%",
                        }}
                      >
                        <div
                          className="iran text-divider"
                          style={{
                            color: ColorPalette.gray[950],
                            backgroundColor: "transparent",
                            fontSize: 16,
                            margin: "auto",
                            height: "45px",
                          }}
                        >
                          &nbsp; &nbsp;
                          {" دعوت نامه های دیگر "}
                          &nbsp; &nbsp;
                        </div>
                      </div>
                    </Row>
                    {getOtherInvitations
                      .filter(
                        (item: any) =>
                          item.invitationCode.code !== getInvitationCode &&
                          !item.isDeleted
                      )
                      .slice(0, 2)
                      .map((p: any) => {
                        return (
                          <>
                            {" "}
                            {p.invitationType === 0 ? (
                              <>
                                <Row style={{ marginTop: "24px" }}>
                                  <CustomButton
                                    onClick={() =>
                                      setInvitationCode(p?.invitationCode?.code)
                                    }
                                    customSize="XLarge"
                                    customType="Secondary"
                                    hasTitle={true}
                                    style={{ width: "320px", margin: "auto" }}
                                  >
                                    دعوت نامه همکار : {p.company.name} در سمت{" "}
                                    {p.position.name}
                                  </CustomButton>
                                </Row>
                              </>
                            ) : (
                              <>
                                <Row style={{ marginTop: "24px" }}>
                                  <CustomButton
                                    onClick={() =>
                                      setInvitationCode(p?.invitationCode?.code)
                                    }
                                    customSize="XLarge"
                                    customType="Secondary"
                                    hasTitle={true}
                                    style={{ width: "320px", margin: "auto" }}
                                  >
                                    دعوت نامه فروشگاهی : {p.company.name}
                                  </CustomButton>
                                </Row>
                              </>
                            )}{" "}
                          </>
                        );
                      })}
                    <Row style={{ marginTop: "24px" }}>
                      <CustomButton
                        customSize="XLarge"
                        customType="Link"
                        hasTitle={true}
                        onClick={() => {
                          GetMyInvitations().then((p) => {
                            console.log("All of My Invitations ", p.data.data);
                            setOtherInvitations(p.data.data);
                          });
                          console.log(getOtherInvitations);

                          setOpenDrawer(true);
                        }}
                        style={{ width: "320px", margin: "auto" }}
                      >
                        مشاهده همه دعوت نامه ها
                      </CustomButton>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col style={{ display: state === 4 ? "block" : "none" }}>
                <Row
                  className="iran"
                  style={{
                    marginTop: "10px",
                  }}
                >
                  <Col
                    style={{
                      width: "560px",
                      height: "610px",

                      display: state === 4 ? "block" : "none",
                    }}
                  >
                    <Col>
                      {getInvitationData?.invitationType === 0 ? (
                        <>
                          <Row>
                            <img
                              style={{
                                margin: "auto",
                                width: "187px",
                                height: "102px",
                              }}
                              src={logo}
                            />
                          </Row>
                          <Row
                            style={{
                              textAlign: "center",
                              marginTop: "8px",
                              height: "34px",
                            }}
                          >
                            <div style={{ width: "100%", textAlign: "center" }}>
                              <TedTitle
                                style={{
                                  fontWeight: "600",
                                  fontSize: "16px",
                                  color: "white",
                                  lineHeight: "22.4px",
                                  fontFamily: "YekanBakhVF",
                                }}
                                text="به دیجیتال آگهی خوش آمدید"
                              />
                            </div>
                          </Row>
                          <Col style={{ backgroundColor: "white" }}>
                            <Row
                              style={{
                                marginTop: "8px",
                                height: "34px",
                              }}
                            >
                              <div
                                style={{
                                  marginTop: "24px",
                                  width: "320px",
                                  margin: "auto",
                                  textAlign: "center",
                                }}
                              >
                                <TedTitle
                                  style={{
                                    fontWeight: "325",
                                    fontSize: "16px",
                                    color: ColorPalette.gray[950],
                                    lineHeight: "28.8px",
                                  }}
                                  text={getInvitationTextForState4}
                                />
                              </div>
                            </Row>
                            <Row style={{ marginTop: "98px" }}>
                              <CustomButton
                                customSize="XLarge"
                                style={{ width: "320px", margin: "auto" }}
                                onClick={() => {
                                  InvitationAcceptByInvitationCode(
                                    getInvitationCode,
                                    getPhoneNumber
                                  ).then((p) => {
                                    navigate("/");
                                  });
                                }}
                                type="primary"
                                hasTitle={true}
                              >
                                تایید
                              </CustomButton>
                            </Row>
                            <Row style={{ marginTop: "24px" }}>
                              <CustomButton
                                onClick={() => setState(3)}
                                customType="Secondary"
                                hasTitle={true}
                                customSize="XLarge"
                                style={{ width: "320px", margin: "auto" }}
                              >
                                بازگشت
                              </CustomButton>
                            </Row>
                          </Col>
                        </>
                      ) : (
                        <>
                          <Card
                            style={{
                              height: "691px",
                              width: "319px",
                              margin: "auto",
                            }}
                          >
                            <Row
                              style={{
                                height: "42px",
                                textAlign: "center",
                                marginTop: "29.5px",
                              }}
                            >
                              <Typography.Text
                                className="iran"
                                style={{ fontSize: "24px", fontWeight: 600 }}
                              >
                                تکمیل ثبت نام
                              </Typography.Text>
                            </Row>
                            <Row style={{ marginTop: "32px" }}>
                              <CustomLabel customSize="XLarge">
                                لطفا نام خود / فروشگاه را وارد کنید
                              </CustomLabel>
                            </Row>
                            <Row style={{ fontFamily: "YekanBakhVF" }}>
                              <InputWithIcons
                                size="xlarge"
                                value={getCompanyName}
                                onChange={(e) => setCompanyName(e.target.value)}
                              />
                            </Row>
                            <Row>
                              <div
                                style={{
                                  marginTop: "12px",
                                  display:
                                    getIsEmptyCompanyName === false
                                      ? "none"
                                      : "block",
                                }}
                              >
                                <HintInput customSize="XLarge" status="Error">
                                  لطفا این قسمت را خالی نگذارید
                                </HintInput>
                              </div>
                            </Row>
                            <Row style={{ marginTop: "24px" }}>
                              <CustomLabel customSize="XLarge">
                                لطفا شماره ملی خود را وارد کنید
                              </CustomLabel>
                            </Row>
                            <Row style={{ fontFamily: "YekanBakhVF" }}>
                              <InputWithIcons
                                size="xlarge"
                                value={getCompanyRegistrationCode}
                                onChange={(e) =>
                                  setCompanyRegistrationCode(e.target.value)
                                }
                              />
                            </Row>
                            <Row>
                              <div
                                style={{
                                  marginTop: "12px",
                                  display:
                                    getIsEmptyRegistrationCode === false
                                      ? "none"
                                      : "block",
                                }}
                              >
                                <HintInput customSize="Large" status="Error">
                                  لطفا این قسمت را خالی نگذارید
                                </HintInput>
                              </div>
                            </Row>
                            <Row style={{ marginTop: "36px" }}>
                              <CustomButton
                                onClick={() => {
                                  if (getCompanyName.trim() === "") {
                                    setIsEmptyCompanyName(true);
                                    return;
                                  } else {
                                    setIsEmptyCompanyName(false);
                                  }

                                  if (
                                    getCompanyRegistrationCode.trim() === ""
                                  ) {
                                    setIsEmptyRegistrationCode(true);
                                    return;
                                  } else {
                                    setIsEmptyRegistrationCode(false);
                                  }
                                  CreateCompany({
                                    name: getCompanyName,
                                    registrationCode:
                                      getCompanyRegistrationCode,
                                    invitationCode: getInvitationCode,
                                  }).then(() => setState(5));
                                }}
                                customSize="XLarge"
                                type="primary"
                                hasTitle={true}
                                style={{ width: "100%" }}
                              >
                                تایید
                              </CustomButton>
                            </Row>
                          </Card>
                        </>
                      )}
                    </Col>
                  </Col>
                </Row>
              </Col>
              <Col style={{ display: state === 5 ? "block" : "none" }}>
                <Card
                  style={{
                    marginTop: "20px",
                    height: "691px",
                    width: "319px",
                    margin: "auto",
                  }}
                >
                  <Row>
                    <Typography.Text
                      className="iran"
                      style={{ fontSize: "24px", fontWeight: 600 }}
                    >
                      زمینه کاری
                    </Typography.Text>
                  </Row>
                  <Row style={{ marginTop: "56px" }}>
                    <Tree
                      style={{ maxHeight: "500px", overflow: "scroll" }}
                      className="iran"
                      checkable
                      onExpand={onExpand}
                      expandedKeys={expandedKeys}
                      autoExpandParent={autoExpandParent}
                      onCheck={onCheck}
                      checkedKeys={checkedKeys}
                      selectedKeys={selectedKeys}
                      treeData={treeData}
                    />
                  </Row>
                  <Row style={{ marginTop: "48px" }}>
                    <CustomButton
                      customSize="XLarge"
                      onClick={async () =>
                        NotificationManagementCreate({
                          PositionId: myPosition.id,
                          CategoryIds: checkedKeys,
                        }).then((p) => {
                          if (getInvitationNoticeId === "") {
                            navigate("/");
                          } else {
                            navigate(`/notice/${getInvitationNoticeId}`);
                          }
                        })
                      }
                      type="primary"
                      hasTitle={true}
                      style={{ width: "100%" }}
                    >
                      تایید
                    </CustomButton>
                  </Row>
                </Card>
              </Col>
            </Col>
          </Row>
        </>
      )}
      <Drawer
        title="همه دعوت نامه ها"
        placement={"bottom"}
        width={360}
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
      >
        <div
          style={{
            overflowX: "hidden",
            overflowY: "scroll",

            backgroundColor: "transparent",
          }}
        >
          <div style={{ margin: "auto", width: "320px" }}>
            <Segmented
              style={{ margin: "auto", width: "320px" }}
              onChange={(e) => setDrawerSegment(e)}
              options={[
                { label: "دعوت نامه فروشگاهی", value: "C" },
                { label: "دعوت نامه همکار", value: "P" },
              ]}
            />
          </div>
          {getDrawerSegment === "P" &&
          getOtherInvitations !== null &&
          getOtherInvitations !== undefined ? (
            <>
              <Row
                style={{
                  marginTop: "16px",
                  margin: "auto",
                  width: "320px",
                }}
              >
                {getOtherInvitations
                  .filter(
                    (item: any) =>
                      item.invitationCode.code !== getInvitationCode &&
                      !item.isDeleted &&
                      item?.invitationType === 0
                  )
                  .map((p: any) => {
                    return (
                      <>
                        <CustomButton
                          onClick={() =>
                            setInvitationCode(p?.invitationCode?.code)
                          }
                          customSize="XLarge"
                          customType="Secondary"
                          hasTitle={true}
                          style={{ marginTop: "12px", width: "320px" }}
                        >
                          {p?.company?.name} در سمت {p?.position?.name}
                        </CustomButton>
                      </>
                    );
                  })}
              </Row>
            </>
          ) : (
            <></>
          )}
          {getDrawerSegment === "C" &&
          getOtherInvitations !== null &&
          getOtherInvitations !== undefined ? (
            <>
              <Row
                style={{
                  marginTop: "16px",
                  margin: "auto",
                  width: "320px",
                }}
              >
                {getOtherInvitations
                  .filter(
                    (item: any) =>
                      //item.invitationCode.code !== getInvitationCode &&

                      item?.invitationType === 1
                  )
                  .map((p: any) => {
                    return (
                      <>
                        <CustomButton
                          onClick={() =>
                            setInvitationCode(p?.invitationCode?.code)
                          }
                          customSize="XLarge"
                          customType="Secondary"
                          hasTitle={true}
                          style={{
                            marginTop: "12px",
                            width: "320px",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {p?.company?.name}
                        </CustomButton>
                      </>
                    );
                  })}
              </Row>
            </>
          ) : (
            <></>
          )}
        </div>
      </Drawer>
      <TedModal
        open={getOtherInvitationsModal}
        setOpen={setOtherInvitationsModal}
        content={
          <div
            style={{
              overflowX: "hidden",
              overflowY: "scroll",
              height: "312px",
              backgroundColor: "transparent",
            }}
          >
            <Tabs
              defaultActiveKey="1"
              style={{
                margin: "auto",
                width: "684px",
                height: "312px",
                overflowX: "hidden",
                overflowY: "scroll",
                alignItems: "center",
              }}
              items={items}
              onChange={onChange}
              indicator={{ size: 0, align: "start" }}
            />
          </div>
        }
        header={<div style={{ backgroundColor: "transparent" }}> </div>}
        footer={
          <>
            {" "}
            <CustomButton
              onClick={() => setOtherInvitationsModal(false)}
              customSize="Large"
              customType="Primary"
              style={{ width: "71px" }}
              hasTitle
            >
              بستن
            </CustomButton>{" "}
          </>
        }
      />
    </>
  );
};
export default RegisterV2;
